// extracted by mini-css-extract-plugin
export default {"none":"iKvo"};